window.addEventListener('DOMContentLoaded', () => {
  $('.copy_content').on('click', (event) => {
    $('#page_content').prepend($('#page_title'));
    utils.copyToClipboard('page_content');
    $('#page_container').prepend($('#page_title'));

    event.preventDefault();
  })
})
